import { useState, useEffect } from 'react'
import type { ReactNode } from 'react'

// Component Imports
import { getServerMode, getSystemMode } from '@core/utils/serverHelpers'
import type { Mode, SystemMode } from '@core/types'

import Providers from '@components/Providers'
import AuthLayoutComponent from '@layouts/AuthLayout'
import AppReactToastify from '@/libs/styles/AppReactToastify'

// Util Imports

type Props = {
  children: ReactNode
}

const AuthLayout = ({ children }: Props) => {
  // States
  // @ts-ignore
  const [mode, setMode] = useState<Mode>('light')
  const [systemMode, setSystemMode] = useState<SystemMode>('light')

  // Vars
  const direction = 'ltr'

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const modeValue = await getServerMode()
        const systemModeValue = await getSystemMode()

        setMode(modeValue as Mode)
        setSystemMode(systemModeValue as SystemMode)
      } catch (error) {
        console.error('Error loading settings:', error)
      } finally {}
    }

    loadSettings()
  }, [])

  return (
    <Providers direction={direction}>
      <AuthLayoutComponent systemMode={systemMode}>{children}</AuthLayoutComponent>
      <AppReactToastify direction={direction} hideProgressBar />
    </Providers>
  )
}

export default AuthLayout
